import Application from './application/Application'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

Application.run()
